import React, {useState} from 'react';
import { CardBody,  Col, Form, FormGroup, Label, Row} from 'reactstrap';
import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";
import {useForm} from "react-hook-form";
import SelectGeneric from "../../../components/select/selectGeneric";
import {routProvider} from "../../../providers/routProvider";
import {categoryProvider} from "../../../providers/categoryProvider";
import {typeServicesProvider} from "../../../providers/typeServicesProvider";
import {setFilter} from "../../../redux/actions/generalActions/listActions";
import {connect} from "react-redux";
import Switch from "react-bootstrap-switch";

function ServicesLocationFilters(props) {
    const { filter } = props.listProps
    const { app, udn } = props.mainProps

    const [udnId] = useState(localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')).id : null);

    const fbDataBaseId = app?.fbDataBase?.id
    const [routeId, setRouteId] = useState( filter?.item?.rout?.id || null);
    const [categoryId, setCategoryId] = useState( filter?.item?.category?.id ||null);
    const [typeServiceId, setTypeServiceId] = useState( filter?.item?.services?.id ||null);
    const [resetValues, setResetValues] = useState(false);
    const [onlyRegistered, setOnlyRegistered] = useState(true);

    const {handleSubmit} = useForm();

    const onSubmit = (data, _) => {
        if(!fbDataBaseId)
            return

        const dataFilter = {
            fbDataBase : {  id : fbDataBaseId },
            onlyRegistered : onlyRegistered,
            item : {
                udn : { id : udn.id }
            }
        }

        if (routeId)
            dataFilter.item.rout = { id : routeId };

        if (categoryId)
            dataFilter.item.category = { id : categoryId };

        if (typeServiceId)
            dataFilter.item.services = { id : typeServiceId };

        props.setFilter(dataFilter);
    };

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))
        if(tmpFilter && tmpFilter.item){
            delete tmpFilter.item.rout;
            delete tmpFilter.item.category;
            delete tmpFilter.item.services;
        }
        props.setFilter(tmpFilter);
        setRouteId(null);
        setCategoryId(null)
        setTypeServiceId(null)
        setOnlyRegistered(true)
        setResetValues(!resetValues);
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>Busqueda por Ruta</Label>
                            <SelectGeneric
                                isDisabled={ false }
                                initialValue={ routeId }
                                setExternalValue={ setRouteId }
                                provider={ routProvider }
                                customFilter={{ item: { udn: {id: udnId}}} }
                                resetValue={ resetValues }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Busqueda por Categoria</Label>
                            <SelectGeneric
                                isDisabled={ false }
                                initialValue={ categoryId }
                                setExternalValue={ setCategoryId }
                                provider={ categoryProvider }
                                customFilter={{ item: { udn: {id: udnId}}} }
                                resetValue={ resetValues }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>Busqueda por Tipo de servicio</Label>
                            <SelectGeneric
                                isDisabled={ false }
                                initialValue={ typeServiceId }
                                setExternalValue={ setTypeServiceId }
                                provider={ typeServicesProvider }
                                customFilter={{ item: { udn: {id: udnId}}} }
                                resetValue={ resetValues }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="1">
                        <FormGroup>
                            <Label>Solo en app</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={onlyRegistered}
                                onChange={ () => setOnlyRegistered(!onlyRegistered) }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>

                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(ServicesLocationFilters)